// 拡張子を除いたファイル名を取得
export const getFileNameWithoutExt = (input) => {
  if (!input) return '';
  const name = String(input).split(/[\\/]/).pop();
  // .env のような拡張子なし隠しファイルはそのまま返す
  if (name.startsWith('.') && name.indexOf('.', 1) === -1) return name;
  // 末尾の拡張子のみ除去（a.tar.gz -> a.tar）
  return name.replace(/\.[^.]+$/, '');
};
